import styled from '@emotion/styled';
import { HEADER_HEIGHT, MOBILE_SUBHEADER_HEIGHT } from 'components/navigation/header.constants';
import { Button } from 'ds/components/button';
import { SmallText } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';
import { CommonWrapper, MAX_CONTENT_WIDTH } from 'screens/AgentOfficePages/styled';


export const InfoWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.grey11};
  box-shadow: 0px -1px 0px 0px ${({ theme }) => theme.colors.neutrals.grey8} inset;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    background-color: ${theme.colors.neutrals.white};
  `}
`;

export const InfoContent = styled.div`
  margin: 0 auto;
  max-width: ${MAX_CONTENT_WIDTH}px;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-top: ${theme.spacing(2)};
    padding-bottom: ${theme.spacing(5)};
    max-width: 100%;
  `}
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Logo = styled.div`
  width: 123px;
  height: 123px;
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  line-height: 0;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 90px;
    height: 90px;
    padding: ${theme.spacing(0.75)};
    border: 1px solid ${theme.colors.neutrals.grey8};
    flex-shrink: 0;
  `}
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: ${({ theme }) => theme.borderRadius.tiny};
    overflow: hidden;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    gap: ${theme.spacing(2)};
  `}
`;

export const PhoneButton = styled(Button.withComponent('a'))`
  text-decoration: none;
  display: flex;
  flex-grow: 0;
  white-space: nowrap;
  svg {
    margin-left: 0;
    margin-right: ${({ theme }) => theme.spacing(0.5)};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(1)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: 0;
  `}
`;

export const MainTitle = styled.h1<{ withWrap?: boolean; withMaxWidth?: boolean }>`
  font-weight: 700;
  font-size: ${typographyFontSizeCfg.h2.mobile}px;
  line-height: ${typographyLineHeightCfg.h2.mobile}px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  max-width: ${({ withMaxWidth }) => withMaxWidth ? '366px' : '100%'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${({ withWrap }) => withWrap ? 'pre-wrap' : 'nowrap'};
  ${({ theme, withMaxWidth }) => theme.media.showAt({ at: 2 })`
    max-width: ${ withMaxWidth ? '200px' : '100%'};
    `}
  ${({ theme, withWrap }) => withWrap && theme.media.showAt({ at: 1 })`
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
  `}
`;

export const AddressLine = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const ContactSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  white-space: nowrap;
  > *:last-child {
    margin-left: auto;
  }
`;

export const PhoneIconWrapper = styled.div`
  position: relative;
  line-height: 0;
  svg {
    path {
      fill: ${({ theme }) => theme.colors.neutrals.white};
    }
  }
`;

export const NavigationWrapper = styled.div<{ isSticky: boolean }>`
  background: ${({ theme }) => theme.colors.neutrals.white};
  padding: ${({ theme }) => theme.spacing(1.5)} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  ${({ isSticky }) => isSticky ? `
    position: sticky;
    top: ${HEADER_HEIGHT * 2}px;
    z-index: 12;
  ` : ''};
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    padding: 0;
    border-bottom: 0 none;
  `}
`;

export const InnerWrapper = styled(CommonWrapper)`
  && {
    padding: 0;
    .sub-menu-item:first-of-type {
      margin: 0;
    }
  }
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    height: ${MOBILE_SUBHEADER_HEIGHT}px;
    display: flex;
  `}
`;

export const MobileNavWrapper = styled.div<{ isSticky?: boolean }>`
  height: ${MOBILE_SUBHEADER_HEIGHT}px;
  flex-grow: 1;
  display: flex;
`;

export const SocialWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
